// extracted by mini-css-extract-plugin
module.exports = {"holder":"CodeExample--holder"};